import { connect } from 'react-redux';

import isNil from 'lodash/isNil';

import SkipLink from './skip_link.jsx';

import {
  getCurrentSubpage,
  getMainSectionForSubpage
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getInternalLinkUrl
} from 'zoomforth_codesbane_viewer/lib/app_actions.js';

import { SECTIONS_WRAPPER_ID } from '../viewer/sections/sections_wrapper.ui.jsx';

const mapStateToProps = (state)=> {
  const defaultHref = `#${SECTIONS_WRAPPER_ID}`;

  var focusTarget = defaultHref;

  const currentSubpage = getCurrentSubpage(state);
  const mainSectionForSubpage = getMainSectionForSubpage(state, currentSubpage);

  var href = defaultHref;

  if (!isNil(mainSectionForSubpage)) {
    href = getInternalLinkUrl({
      subpageId: currentSubpage.id,
      subpageSlug: currentSubpage.slug,
      sectionId: mainSectionForSubpage.id
    });

    focusTarget = `#section-id-${mainSectionForSubpage.id}`;
  }

  return { href, focusTarget };
};

const mapDispatchToProps = ()=> {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SkipLink);
